// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t5ba","title":"styles_title__2Mid9"};